// 正则校验
// 邮箱
const emailReg = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$'
// 只能输入数字
const numReg = '^[0-9]*$'
// 手机号码校验
const phoneReg = '^(?:(?:\+|00)86)?1[3-9]\d{9}$'
// 座机号码校验
const landlineNumberReg = '^(0\d{2,3})-(\d{7,8})$'
// 金额(保留13位小数)
// const moneyReg = '^(([1-9][0-9]*\.[0-9][0-9]*)|([0]\.[0-9][0-9]*)|([1-9][0-9]*)|([0]{1}))$'
const moneyReg = '^(([1-9][0-9]*\.[0-9][0-9]*)|([0]\.[0-9][0-9]*)|([1-9][0-9]*)|([0]{1}))\s*(元|万元|万|亿|亿元|千元|百元|角|分|厘)?$'

export default {
    emailReg,
    numReg,
    phoneReg,
    landlineNumberReg,
    moneyReg
}